import React, { useContext } from 'react';
import { connect } from 'react-redux';
import {
  defaultState as configState,
  useConfig,
} from '../../store/reducers/config';
import {
  getUnlimitedAccessText,
  upgradeButtonText,
} from '../../i18n/translations';
import { isApple } from '../../helpers/is-apple';

import './index.scss';
import { modalContext } from '../upgrade-modal/modal.provider';

interface IProps {
  isPaused: boolean;
}

interface IStateProps {
  config: typeof configState;
}

export const SignUpAccess: React.FC<IProps> = props => {
  const { setIsVisible } = useContext(modalContext);
  const { platform } = useConfig();
  function openModal(): void {
    setIsVisible(true);
    if (typeof window != 'undefined' && window.document) {
      document.body.style.overflow = 'hidden';
    }
  }

  return isApple(platform) ? null : (
    <div className="free-expired" data-testid="free-expired">
      <p>{getUnlimitedAccessText()}</p>
      {!props.isPaused && (
        <button onClick={openModal}>{upgradeButtonText()}</button>
      )}
    </div>
  );
};
export default connect((state: IStateProps) => ({
  isPaused: state.config.isPaused,
}))(SignUpAccess);
